export default "__VITE_ASSET__BL_rdye5__"